<template>
    <i :class="`yy-icon yy-icon-${type}`"
        :style="{
            fontSize: size
        }"></i>
</template>
<script>
export default {
    name: 'YYIcon',
    props: {
        type: {
            type: String
        },
        size: {
            type: String,
            default: '12px'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/base/icon/index.vue